import { scopedKey, getActiveUid } from "./userScope";

function key() {
  return scopedKey("tasks.v1");
}

export const TASK_CATEGORIES = [
  { id: "work", label: "Work", emoji: "💼" },
  { id: "exercise", label: "Exercise", emoji: "🏋️" },
  { id: "chores", label: "Chores", emoji: "🏠" },
  { id: "general", label: "General", emoji: "📋" },
];
export const TASK_CAT_MAP = Object.fromEntries(TASK_CATEGORIES.map((c) => [c.id, c]));

function readAll() {
  try { const r = localStorage.getItem(key()); return r ? JSON.parse(r) : []; } catch { return []; }
}
// Live (non-soft-deleted) tasks only.
function readLive() {
  return readAll().filter((t) => !t.deletedAt);
}
function write(arr) {
  localStorage.setItem(key(), JSON.stringify(arr));
  window.dispatchEvent(new CustomEvent("chronicles:tasks-changed"));
}
function id() {
  return (crypto?.randomUUID && crypto.randomUUID()) || `t-${Date.now()}-${Math.random().toString(36).slice(2,9)}`;
}
function nowISO() {
  return new Date().toISOString();
}

export function getAllTasks() { return readLive(); }
export function getTaskById(tid) { return readLive().find((t) => t.id === tid) || null; }

export function createTask(p) {
  const now = nowISO();
  const t = {
    id: id(),
    userId: getActiveUid() || null,
    creationDate: now,
    createdAt: now,
    updatedAt: now,
    version: 1,
    status: "unknown",
    archived: false,
    ...p,
  };
  write([...readAll(), t]);
  return t;
}

export function updateTask(tid, patch) {
  const now = nowISO();
  write(readAll().map((t) => {
    if (t.id !== tid) return t;
    const next = {
      ...t,
      ...patch,
      id: tid,
      userId: t.userId || getActiveUid() || null,
      createdAt: t.createdAt || t.creationDate || now,
      updatedAt: now,
      lastEditedAt: now,
      version: (t.version || 1) + 1,
    };
    // Track archivedAt without changing archive behaviour.
    if (patch && Object.prototype.hasOwnProperty.call(patch, "archived")) {
      if (patch.archived) next.archivedAt = t.archivedAt || now;
      else next.archivedAt = null;
    }
    return next;
  }));
}

// Soft delete: preserve the record with a deletedAt timestamp.
export function deleteTask(tid) {
  const now = nowISO();
  write(readAll().map((t) =>
    t.id === tid
      ? { ...t, deletedAt: now, updatedAt: now, version: (t.version || 1) + 1 }
      : t
  ));
}

export function sortTasks(arr) {
  return [...arr].sort((a, b) => {
    if (a.targetDate !== b.targetDate) return (a.targetDate || "9999") < (b.targetDate || "9999") ? -1 : 1;
    if ((b.priority || 0) !== (a.priority || 0)) return (b.priority || 0) - (a.priority || 0);
    return (a.creationDate || "").localeCompare(b.creationDate || "");
  });
}
